import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import getLoginUrl from '@app/routes/getLoginUrl';
import useBaseUrl from '@app/hooks/useBaseUrl';

const LoginLink: FC = ({ children }) => {
  const { pathname } = useLocation();
  const baseUrl = useBaseUrl();

  return (
    <a data-testid="login-link" href={getLoginUrl(baseUrl, pathname)}>
      {children}
    </a>
  );
};

export default LoginLink;
